export const PRODUCT_ENGAGEMENT_EVENT_NAMES = [
    'site_scan_started',
    'site_scan_completed',
    'site_scan_failed',
    // A welcome scan a deploy killed, started again for the same session. Not
    // in the growth funnel's list, so a restart never counts as a second start.
    'site_scan_restarted',
    'business_context_viewed',
    'business_context_confirmed',
    'ai_questions_viewed',
    'ai_questions_confirmed',
    'locked_report_reached',
    'account_claimed',
    'onboarding_intent_started',
    'onboarding_intent_completed',
    'ai_answer_checks_started',
    'ai_answer_checks_completed',
    'first_page_setup_clicked',
    'site_scan_results_viewed',
    'ai_visibility_scan_started',
    'ai_visibility_scan_completed',
    'ai_visibility_scan_failed',
    'page_setup_launcher_used',
    'page_setup_started',
    'schema_generated',
    'deploy_instructions_viewed',
    'install_package_copied',
    'verification_started',
    'verification_succeeded',
    'verification_failed',
    'monitoring_enabled',
    'monitoring_viewed',
    'monitoring_health_viewed',
    'monitoring_recheck_requested',
    'bot_tracking_viewed',
    'bot_tracking_pixel_copied',
    'first_bot_visit_detected',
    'schema_score_viewed',
    'hubspot_connected',
    'hubspot_portal_matched',
    // Put it live, from the onboarding report: the page was published to the
    // customer's HubSpot, then a fresh read of the live page saw it there.
    'first_page_put_live',
    'first_page_confirmed',
    'hubspot_deploy_attempted',
    'hubspot_deploy_succeeded',
    'hubspot_deploy_failed',
    'domain_added',
    'domain_updated',
    'domain_removed',
    'welcome_results_viewed',
    // The counterpart to welcome_results_viewed: the results page gave up without
    // ever rendering a report. Recorded ANONYMOUSLY through a public endpoint,
    // because the most likely cause is a 401 and an authenticated write would be
    // rejected by the very failure it is trying to report.
    'welcome_results_failed',
    // Fired server-side when an existing user (account older than the scan
    // session) hits the onboarding gate and signs in, instead of a new signup.
    // They are blocked from a free re-scan. Deliberately NOT wired into the
    // onboarding funnel stage map: adding a stage would reshape the chart we are
    // measuring this change against. Carries hasSubscription so the free ones
    // (upsell targets) separate from the paid ones.
    'existing_user_rescan_blocked',
    'ai_answers_viewed',
    'ai_answer_row_expanded',
    'ai_recommendation_score_snapshot',
    'scan_findings_viewed',
    'category_breakdown_viewed',
    'continued_to_dashboard',
    'page_setup_cta_clicked',
    'page_setup_route_entered',
    'first_page_setup_started',
    'verified_business_profile_saved',
    'first_schema_generated',
    'first_ai_readable_files_generated',
    'first_deploy_attempted',
    'first_schema_verified',
    'schema_deployment_attempted',
    'schema_deployment_succeeded',
    'schema_deployment_failed',
    'team_invite_sent',
    'team_member_joined',
    'billing_plans_viewed',
    'dashboard_subscription_nudge_viewed',
    'dashboard_subscription_nudge_clicked',
    'domain_citation_summary_viewed',
    'domain_citation_detail_viewed',
    'domain_citation_questions_edited',
    'domain_citation_rescan_started',
    'domain_citation_rescan_completed',
    'domain_citation_rescan_limit_reached',
    'checkout_started',
    'subscription_started',
    'subscription_canceled',
    'results_upgrade_cta_viewed',
    'results_upgrade_cta_clicked',
    'results_plan_selected',
    // The fix shown inline on the results report. Raw events on purpose: they are
    // NOT wired into the growth funnel's stage map, because adding stages would
    // silently reshape the chart we are measuring this change against. _viewed
    // carries whether the build actually succeeded, so "nobody saw a fix" and
    // "everybody saw one and still did not buy" stay distinguishable.
    'onboarding_fix_build_viewed',
    'onboarding_fix_lock_engaged',
    // The 7-day trial, kept strictly apart from subscription_started.
    //
    // Before these existed, subscription_started fired when a subscription
    // arrived in 'trialing' AND was suppressed on trialing -> active by the
    // double-count guard. Shipping a trial on top of that would have moved the
    // event from "someone paid" to "someone started a trial" and silenced it at
    // the moment money actually moved: a conversion lift that is purely an
    // instrumentation artifact, in the direction that looks like success.
    //
    // trial_converted is the clean numerator for the experiment.
    // subscription_started keeps meaning revenue, so historical dashboards stay
    // comparable.
    'trial_started',
    'trial_converted',
    // The trial paywall as its own page, reached from Put it live. Viewed
    // carries the default tier and the site's page count; plan_selected
    // carries the tier picked. Raw events, and trial_paywall_viewed is also a
    // tracked (never ordered) stage on the growth board, so the number of
    // people who reached the paywall can be read beside the number who put a
    // page live.
    'trial_paywall_viewed',
    'trial_paywall_plan_selected',
    // A HubSpot-path account came back before starting its trial; sent once an hour at most.
    'onboarding_return_pending',
    // The first-week guide on the dashboard after the trial checkout. Viewed
    // carries source ('checkout' on arrival, 'dashboard' after). Step completed
    // carries { step, byUserId } and is emitted by the server when a step first
    // reads done for the team, never by the client. Branch answered carries
    // { branch } when the guide asks who runs the site.
    'first_week_viewed',
    'first_week_step_completed',
    'first_week_dismissed',
    'first_week_branch_answered',
    // Chief of Staff adoption. Without these, `chief_access` only records who
    // finished opting in, so "nobody found the nav item" and "plenty read the
    // pitch and declined" are indistinguishable, and they call for opposite
    // responses. _clicked fires on the CLICK rather than on success on purpose:
    // clicks materially exceeding rows in chief_access is the signal that the
    // opt-in is failing, which is the one thing enrolment counts can never show.
    'chief_landing_viewed',
    'chief_optin_clicked',
];
export const PRODUCT_ENGAGEMENT_EVENT_SET = new Set(PRODUCT_ENGAGEMENT_EVENT_NAMES);
export function isProductEngagementEventName(eventName) {
    return PRODUCT_ENGAGEMENT_EVENT_SET.has(eventName);
}
